/** QuickRouter — Connecteurs du DESSOUS de l'Arduino VENTUNO Q, côté carte porteuse.
 *
 * Sur la VENTUNO Q : femelles Greenconn CSEC202 au pas de 1,27 mm (schéma ABX00181 :
 * JMEDIA/JMISC = CSEC202-3002A001C1AF, 2×30 ; JOMEGA = CSEC202-5002A001C1AF, 2×50).
 * Sur la porteuse : barrette MÂLE CMS 2×N au pas de 1,27 mm (empreinte type KiCad
 * PinHeader_2xNN_P1.27mm_Vertical_SMD : pastilles 0,76 × 2,4 à ±1,95 mm de l'axe).
 *
 * Repère : celui du gabarit ventuno-q (vue de DESSUS, à travers la VENTUNO Q posée sur la
 * porteuse). Origine de l'empreinte = centre du connecteur, colonnes selon X, broches 1-2
 * à l'extrémité +X (côté façade de la VENTUNO Q, sérigraphie « 2 1 » lue au dos de la carte).
 * Noms des broches = désignations de la fiche (§9.7 à §9.9).
 */
import { FootprintSchema } from '../schema.js';

const r3 = (v) => Math.round(v * 1000) / 1000;

export const JMISC_NAMES = [
  "MCU_PSSI_D0", "MCU_TRACE_CLK", "MCU_PSSI_D1", "MCU_TRACE_D0", "MCU_PSSI_D2", "MCU_TRACE_D1",
  "MCU_PSSI_D3", "MCU_TRACE_D2", "MCU_PSSI_D4", "MCU_TRACE_D3", "MCU_PSSI_D5", "MCU_USART2_RX",
  "MCU_PSSI_D6", "MCU_USART2_TX", "MCU_PSSI_D7", "MCU_I2C_SCL", "MCU_PSSI_PDCK", "MCU_I2C_SDA",
  "MCU_PSSI_RDY", "MCU_GPIO_PA0", "MCU_PSSI_DE", "MCU_GPIO_PA1", "MCU_UART4_RX", "MCU_GPIO_PA2",
  "MCU_UART4_TX", "GND", "GND", "EAR_P", "MIC_INP", "EAR_M",
  "MIC_INN", "LINEOUT_P", "MIC_BIAS", "LINEOUT_M", "GND", "HPH_L",
  "SOC_SPI_MISO", "HPH_R", "SOC_SPI_MOSI", "HPH_REF", "SOC_SPI_SCK", "HS_DET",
  "SOC_SPI_CS0", "GND", "SOC_SPI_CS2", "SOC_MI2S_SCK", "SOC_SPI_CS1", "SOC_MI2S_WS",
  "SOC_GPIO_73", "SOC_MI2S_DATA0", "SOC_GPIO_74", "SOC_MI2S_DATA1", "3V3", "5V",
  "3V3", "5V", "SOM_VREG_MDPX3_1P8", "GND", "VBAT", "NC",
];

export const JMEDIA_NAMES = [
  "GND", "GND", "MIPI_DSI0_CLK_M", "MIPI_DSI0_L1_P", "MIPI_DSI0_CLK_P", "MIPI_DSI0_L1_M",
  "GND", "GND", "MIPI_DSI0_L2_M", "MIPI_DSI0_L0_P", "MIPI_DSI0_L2_P", "MIPI_DSI0_L0_M",
  "GND", "GND", "MIPI_DSI0_L3_M", "SOC_CAM_MCLK0", "MIPI_DSI0_L3_P", "SOC_CAM_MCLK1",
  "GND", "GND", "CSI0_LN0_M", "CCI_I2C2_SDA", "CSI0_LN0_P", "CCI_I2C2_SCL",
  "GND", "GND", "CSI0_LN1_M", "CSI1_LN3_P", "CSI0_LN1_P", "CSI1_LN3_M",
  "GND", "GND", "CSI0_CLK_M", "CSI1_LN2_P", "CSI0_CLK_P", "CSI1_LN2_M",
  "GND", "GND", "CSI0_LN2_M", "CSI1_CLK_P", "CSI0_LN2_P", "CSI1_CLK_M",
  "GND", "GND", "CSI0_LN3_M", "CSI1_LN1_P", "CSI0_LN3_P", "CSI1_LN1_M",
  "GND", "GND", "CCI_I2C0_SCL", "CSI1_LN0_P", "CCI_I2C0_SDA", "CSI1_LN0_M",
  "GND", "GND", "VIN", "3V3", "VIN", "3V3",
];

export const JOMEGA_NAMES = [
  "VIN", "GND", "VIN", "GND", "VIN", "GND",
  "VIN", "GND", "VIN", "GND", "VIN", "GND",
  "VIN", "GND", "GND", "GND", "GND", "USB3.0_1_SS_TX_P",
  "GND", "USB3.0_1_SS_TX_N", "GND", "GND", "GND", "USB3.0_1_HS_D_P",
  "GND", "USB3.0_1_HS_D_N", "GND", "GND", "GND", "USB3.0_1_SS_RX_P",
  "GND", "USB3.0_1_SS_RX_N", "GND", "GND", "GND", "USB3.0_2_SS_TX_P",
  "GND", "USB3.0_2_SS_TX_N", "IO0_3V3", "GND", "IO1_3V3", "USB3.0_2_HS_D_P",
  "IO2_3V3", "USB3.0_2_HS_D_N", "IO3_3V3", "GND", "IO4_3V3", "USB3.0_2_SS_RX_P",
  "IO5_3V3", "USB3.0_2_SS_RX_N", "IO6_3V3", "GND", "IO7_3V3", "USB3.0_1_PWRON_3V3",
  "IO8_3V3", "USB3.0_1_OVERCUR_3V3", "MIC_INP", "USB3.0_2_PWRON_3V3", "MIC_INN", "USB3.0_2_OVERCUR_3V3",
  "MIC_BIAS", "SPI_ICS_MISO", "TMS", "SPI_ICS_MOSI", "TDO", "SPI_ICS_SCK",
  "TDI", "SPI_ICS_CS", "TCK", "PM_PS_HOLD_1V8", "SRST_N", "FORCED_USB_BOOT_1V8",
  "TRST_N", "PWR_EN_N", "GND", "USER_BUTTON", "SOM_VREG_S5S_SPX3_1P8", "PM_RESIN_N_3V3",
  "SOM_VREG_MDPX3_1P8", "RTSS_RESIN_N_1V8", "SOM_VREG_MDPX3_1P8", "RTSS_PS_HOLD_SPX3_1P8_1V8", "UART_DBG_TX", "GND",
  "UART_DBG_RX", "CAN1_TX", "PWR_DISABLE_7-24V", "CAN1_RX", "FORCE_BOOT_3V3", "GND",
  "3V3", "CAN2_TX", "3V3", "CAN2_RX", "3V3", "GND",
  "5V", "CAN3_TX", "5V", "CAN3_RX",
];

/** Barrette mâle CMS 2×cols au pas de 1,27 : rangée impaire côté +Y si oddHigh. */
function carrierHeader(id, name, cols, names, oddHigh, description) {
  const pads = [];
  const x0 = ((cols - 1) * 1.27) / 2;
  const yo = oddHigh ? 1 : -1;
  for (let c = 0; c < cols; c++) {
    const x = r3(x0 - c * 1.27);
    pads.push({ num: String(2 * c + 1), name: names[2 * c], shape: 'rect', pos: [x, r3(yo * 1.95)], size: [0.76, 2.4] });
    pads.push({ num: String(2 * c + 2), name: names[2 * c + 1], shape: 'rect', pos: [x, r3(-yo * 1.95)], size: [0.76, 2.4] });
  }
  const w = cols * 1.27 + 0.6;
  return FootprintSchema.parse({
    id, name, category: 'Cartes mères', refPrefix: 'J', description,
    pads,
    silk: [
      { kind: 'poly', pts: [[r3(-w / 2), -1.7], [r3(w / 2), -1.7], [r3(w / 2), 1.7], [r3(-w / 2), 1.7], [r3(-w / 2), -1.7]], width: 0.12 },
      { kind: 'circle', pts: [[r3(x0 + 1.1), r3(yo * 3.4)]], r: 0.25, width: 0.12, fill: true },
    ],
    courtyard: [[r3(-w / 2 - 0.3), -3.5], [r3(w / 2 + 0.3), 3.5]],
    body: { size: [r3(w), 3.4, 2.6], color: '#111' },
    tags: ['CMS', '1.27', 'VENTUNO Q', 'carte porteuse'],
  });
}

const COMMON = 'Côté carte porteuse (dessous de la VENTUNO Q) : barrette mâle CMS 2 rangées au pas de 1,27 mm, contrepartie des femelles Greenconn CSEC202 de la carte — choisir la référence mâle et la hauteur d’empilage dans le catalogue Greenconn (série 1,27 mm double rangée) et VÉRIFIER l’empreinte sur sa fiche. Broche 1 repérée par le point.';

export const VQ_BOTTOM_FOOTPRINTS = [
  carrierHeader('vq-jmisc-carrier', 'VENTUNO Q — JMISC (2×30, porteuse)', 30, JMISC_NAMES, false,
    `${COMMON} JMISC : bus caméra parallèle PSSI, GPIO, I2C2 (MCU_I2C_SDA/SCL) et UART du MCU en 3,3 V ; audio analogique (micro, casque, haut-parleur, ligne) ; SPI, I2S et GPIO du MPU en 1,8 V (ne pas mélanger les domaines). Alimentations : 3V3 et 5V en SORTIE, SOM_VREG_MDPX3_1P8 (ne rien y appliquer), VBAT = pile de sauvegarde RTC ≤ 3,3 V.`),
  carrierHeader('vq-jmedia-carrier', 'VENTUNO Q — JMEDIA (2×30, porteuse)', 30, JMEDIA_NAMES, false,
    `${COMMON} JMEDIA : MIPI DSI 4 voies (écran, partagé avec l’HDMI) et MIPI CSI0/CSI1 (paires différentielles D-PHY 100 Ω : router par paires, longueurs égales, plan de masse continu, jamais en GPIO), horloges et I2C caméra en 1,8 V. VIN (57, 59) = entrée 7-24 V protégée 1,5 A (alimente une porteuse, pas toute la carte) ; 3V3 en sortie.`),
  carrierHeader('vq-jomega-carrier', 'VENTUNO Q — JOMEGA (2×50, porteuse)', 50, JOMEGA_NAMES, true,
    `${COMMON} JOMEGA : 2 ports USB 3.0 (paires SuperSpeed 90 Ω et HighSpeed), 3 bus CAN-FD SANS transceiver (CANx_TX/RX en 3,3 V : ajouter un émetteur-récepteur), GPIO IO0-IO8 du MCU en 3,3 V, JTAG / SPI / UART de débogage du MPU en 1,8 V, commandes d’alimentation. VIN (1-13 impairs) = entrée 7-24 V, 3V3 et 5V en sortie.`),
];
